/**
 * ContentLibraryProviders
 *
 * Composes the per-game-module providers that back the Content Library so the
 * library (and any game's round settings that read it) works app-wide,
 * independent of the selected game. Mounted once near the app root.
 *
 * Today only Trailblazers contributes a provider (its screenshot library); new
 * modules nest their own provider here.
 */

import { ReactNode } from 'react';
import { TrlImageLibraryProvider } from './trailblazers';

interface ContentLibraryProvidersProps {
  children: ReactNode;
}

export function ContentLibraryProviders({ children }: ContentLibraryProvidersProps) {
  return <TrlImageLibraryProvider>{children}</TrlImageLibraryProvider>;
}
